import { axios } from '@/utils/request'
// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'
import enterpriseDetails from '@/views/enterprise/EnterpriseDetails'

// 前端路由表
const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: BasicLayout,
  BlankLayout: BlankLayout,
  RouteView: RouteView,
  PageView: PageView,
  // 你需要动态引入的页面组件
  analysis: () => import('@/views/dashboard/Analysis'),
  workplace: () => import('@/views/dashboard/Workplace'),
  weclome: () => import('@/views/dashboard/Welcome'),
  monitor: () => import('@/views/dashboard/Monitor'),
  dataCenter: () => import('@/views/dashboard/DataCenter'), // 数据中心
  workbench: () => import('@/views/dashboard/Workbench'), // 工作台
  baseForm: () => import('@/views/form/BasicForm'),
  stepForm: () => import('@/views/form/stepForm/StepForm'),
  advancedForm: () => import('@/views/form/advancedForm/AdvancedForm.vue'),

  tableList: () => import('@/views/list/TableList'),
  standardList: () => import('@/views/list/StandardList'),
  cardList: () => import('@/views/list/CardList'),
  search: () => import('@/views/list/search/SearchLayout'),
  article: () => import('@/views/list/search/Article'),
  project: () => import('@/views/list/search/Projects'),
  application: () => import('@/views/list/search/Applications'),
  // 企业账单 finance
  enterpriseBill: () => import('@/views/finance/EnterpriseBill'),
  enterpriseStatement: () => import('@/views/finance/EnterpriseStatement'),
  CustomerExpense: () => import('@/views/finance/CustomerExpense'),
  masterBill: () => import('@/views/finance/MasterBill'),
  // masterSingle
  EnterpriseBill: () => import('@/views/finance/EnterpriseBill'),

  statementList: () => import('@/views/finance/statementList'),
  customerList: () => import('@/views/finance/customerList'),
  MasterStatementList: () => import('@/views/finance/MasterStatementList'),
  // MasterStatementList
  customerStatementsList: () => import('@/views/finance/customerStatementsList'),
  // 师傅保证金MasterDeposit
  MasterDeposit: () => import('@/views/finance/MasterDeposit'),
  profileBasic: () => import('@/views/profile/basic/Index'),
  profileAdvanced: () => import('@/views/profile/advanced/Advanced'),
  resultSucc: () => import('@/views/result/Success'),
  resultErr: () => import('@/views/result/Error'),
  error403: () => import('@/views/exception/403'),
  error404: () => import('@/views/exception/404'),
  error500: () => import('@/views/exception/500'),
  center: () => import('@/views/account/center/Index'),
  settings: () => import('@/views/account/settings/Index'),
  base: () => import('@/views/account/settings/BaseSetting'),
  security: () => import('@/views/account/settings/Security'),
  custom: () => import('@/views/account/settings/Custom'),
  binding: () => import('@/views/account/settings/Binding'),
  notification: () => import('@/views/account/settings/Notification'),
  // system
  userList: () => import('@/views/system/UserList'),
  roleList: () => import('@/views/system/RoleList'),
  permissionList: () => import('@/views/system/PermissionList'),
  deptList: () => import('@/views/system/DeptList'),
  dictList: () => import('@/views/system/DictList'),
  distList: () => import('@/views/system/DistList'),
  configList: () => import('@/views/system/ConfigList'),
  ossList: () => import('@/views/system/OssList'),
  customerServiceRecord: () => import('@/views/system/customerServiceRecord'),
  // monitor
  operLogList: () => import('@/views/monitor/OperLogList'),
  loginLogList: () => import('@/views/monitor/LoginLogList'),
  // gen
  genList: () => import('@/views/gen/GenList'),
  genEdit: () => import('@/views/gen/GenEdit'),
  jobList: () => import('@/views/monitor/JobList'),
  processList: () => import('@/views/workflow/WorkFlowList'),
  // enterprise
  enterpriseAccount: () => import('@/views/enterprise/enterpriseAccount'),
  Offlinepayment: () => import('@/views/enterprise/Offlinepayment'),
  imagesList: () => import('@/views/enterprise/imagesList'),
  brandList: () => import('@/views/enterprise/BBrandList'),
  brandEdit: () => import('@/views/enterprise/BBrandList'),
  brandSearch: () => import('@/views/enterprise/BBrandList'),
  brandRemove: () => import('@/views/enterprise/BBrandList'),
  channelList: () => import('@/views/enterprise/ChannelList'),
  channelSearch: () => import('@/views/enterprise/ChannelList'),
  channelAdd: () => import('@/views/enterprise/ChannelList'),
  channelRemove: () => import('@/views/enterprise/ChannelList'),
  sourceList: () => import('@/views/enterprise/SourceList'),

  EnterpriseShopList: () => import('@/views/enterprise/EnterpriseShopList'),

  CustomerOrderTemplate: () => import('@/views/enterprise/CustomerOrderTemplate'),
  accessoryList: () => import('@/views/enterprise/AccessoryList'),
  sourceSearch: () => import('@/views/enterprise/SourceList'),
  sourceAdd: () => import('@/views/enterprise/SourceList'),
  sourceRemove: () => import('@/views/enterprise/SourceList'),
  modelList: () => import('@/views/enterprise/ModelList'),
  enterpriseConfiguration: () => import('@/views/enterprise/ModelList'),
  enterpriseQueryList: () => import('@/views/enterprise/enterpriseQueryList'),
  workflowModelList: () => import('@/views/workflow/ModelList'),
  instanceList: () => import('@/views/workflow/InstanceList'),
  // modelList: () => import('@/views/enterprise/ModelList1'),
  // modelSearch: () => import('@/views/enterprise/ModelList1'),
  // modelAdd: () => import('@/views/enterprise/ModelList1'),
  // modalEnterpriseConfiguration: () => import('@/views/enterprise/MoelList')
  compalaintList: () => import('@/views/complaint/compalaintList'),
  storageRecord: () => import('@/views/accessory/storageRecordList'),
  historyInstanceList: () => import('@/views/workflow/HistoryInstanceList'),
  // historyInstanceList: () => import('@/views/workflow/HistoryInstanceList'),

  // 库存管理
  accessorySearch: () => import('@/views/accessory/accessorySearch'),
  SupplierList: () => import('@/views/accessory/SupplierList'),
  commodity: () => import('@/views/accessory/commodity'),
  commodity2: () => import('@/views/accessory/modules/commodityCondimentsModel'),
  Stockparts: () => import('@/views/accessory/stockParts'),
  storageAccessory: () => import('@/views/accessory/StorageAccessoryList'),
  databaseManagement: () => import('@/views/accessory/StoreList'),

  EnterpriseOrderManagement: () => import('@/views/enterprise/EnterpriseOrderManagement'),
  enterpriseProblemList: () => import('@/views/enterprise/EnterpriseProblemList'),
  enterpriseBlackList: () => import('@/views/enterprise/EnterpriseBlackList'),
  enterpriseContractList: () => import('@/views/enterprise/EnterpriseContractList'),
  enterpriseRegistration: () => import('@/views/enterprise/EnterpriseRegistration'),
  enterpriseconfiguration: () => import('@/views/enterprise/modules/Enterpriseconfiguration'),
  enterpriseCustomization: () => import('@/views/enterprise/EnterpriseCustomization'),
  enterpriseList: () => import('@/views/enterprise/EnterpriseList'),
  enterpriseDetails: () => import('@/views/enterprise/EnterpriseDetails'),
  districtPriceList: () => import('@/views/enterprise/DistrictPriceList'),
  entUserList: () => import('@/views/enterprise/EntUserList'),
  entRoleList: () => import('@/views/enterprise/EntRoleList'),
  // 订单管理
  OrderTimeout: () => import('@/views/order/OrderTimeout'),
  PartsOrder: () => import('@/views/order/PartsOrder'),
  Chargebacks: () => import('@/views/order/Chargebacks'),
  orderList: () => import('@/views/order/orderList'),
  createOrder: () => import('@/views/order/createOrder'),
  qyCreateOrder: () => import('@/views/order/qyCreateOrder'),
  orderCourse: () => import('@/views/order/orderCourse'),
  qyOrderList: () => import('@/views/order/qyOrderList'),
  qyOrderDetail: () => import('@/views/order/qyOrderDetail'),
  dxOrderList: () => import('@/views/order/dxOrderList'),
  dxOrderDetail: () => import('@/views/order/dxOrderDetail'),
  CTEIList: () => import('@/views/order/CTEIList'),
  orderList1: () => import('@/views/order/orderList1'),
  MasterOrderList: () => import('@/views/order/MasterOrderList'),
  ReviewList: () => import('@/views/order/ReviewList'),
  AccessoryNewlyadded: () => import('@/views/enterprise/AccessoryNewlyadded'),
  orderDetails: () => import('@/views/order/orderDetails'),
  orderBack: () => import('@/views/order/orderBack'),
  // 加价列表
  increaseAuditList: () => import('@/views/order/increaseAuditList'),

  orederRecovery: () => import('@/views/order/orederRecovery'),
  customerOrderManage: () => import('@/views/order/customerOrder'),
  moneyExamine: () => import('@/views/order/moneyExamine'),
  feedback: () => import('@/views/order/feedback'),
  cancelList: () => import('@/views/order/cancelList'),
  leaveDemo: () => import('@/views/workflow/LeaveDemo'),
  customerInforOrder: () => import('@/views/order/customerInforOrder'),
  // feedback
  // SaveModal: () => import('@/views/enterprise/modules/SaveModal')
  // enterpriseConfiguration: () => import('@/views/enterprise/modules/EnterpriseContractModal')
  // enterpriseBlackList: () => import('@/views/enterprise/EnterpriseBlackListList')
  // : () => import('@/views/enterprise/'),
  // Add: () => import('@/views/enterprise/enterpriseRegisterList'),
  // ...more

  // activiti
  businessList: () => import('@/views/activiti/BusinessList'),
  tasking: () => import('@/views/activiti/Tasking'),
  taskdone: () => import('@/views/activiti/Taskdone'),
  activitiModelList: () => import('@/views/activiti/ModelList'),
  procDef: () => import('@/views/activiti/ProcDefList'),
  procInstRuns: () => import('@/views/activiti/ProcInstRuns'),
  procInstFinished: () => import('@/views/activiti/ProcInstFinished'),
  leave: () => import('@/views/activiti/modules/Leave'),
  procDefList: () => import('@/views/activiti/ProcDefList'),
  procDefNode: () => import('@/views/activiti/ProcDefNode'),

  // 基础数据
  provincialdowntownstreet: () => import('@/views/basicdatas/Provincialdowntownstreet'),
  enterpriseTest: () => import('@/views/enterprise/EnterpriseTest'),
  orderinstallinfo: () => import('@/views/basicdatas/Orderinstallinfo'),
  extrachargetypemanagement: () => import('@/views/basicdatas/Extrachargetypemanagement'),
  noticeadministration: () => import('@/views/basicdatas/Noticeadministration'),
  customerordersetting: () => import('@/views/basicdatas/Customerordersetting'),
  digitaldictionary: () => import('@/views/basicdatas/Digitaldictionary'),
  CustomArea: () => import('@/views/basicdatas/CustomArea'),
  OrderTemplate: () => import('@/views/basicdatas/OrderTemplate'),
  OrderType: () => import('@/views/basicdatas/OrderType'),
  AmountManagement: () => import('@/views/basicdatas/AmountManagement'),
  Backlog: () => import('@/views/basicdatas/Backlog'),
  Configuration: () => import('@/views/basicdatas/Configuration'),
  DataBank: () => import('@/views/basicdatas/DataBank'),
  ReviewDifference: () => import('@/views/basicdatas/ReviewDifference'),
  GrabArea: () => import('@/views/basicdatas/GrabArea'), // 抢单区域
  // 师傅管理
  MasterList: () => import('@/views/master/MasterList'),
  MasterScore: () => import('@/views/master/MasterScore'),
  ContractManagement: () => import('@/views/master/ContractManagement'),
  LabelManagement: () => import('@/views/master/LabelManagement'),
  RegionalDivision: () => import('@/views/master/RegionalDivision'),
  ComplaintAuthority: () => import('@/views/master/ComplaintAuthority'),
  TeamManagement: () => import('@/views/master/TeamManagement'),
  MasterBlacklist: () => import('@/views/master/MasterBlacklist'),
  teamRoleList: () => import('@/views/master/TeamRoleList'),
  MasterAppraisalForm: () => import('@/views/master/MasterAppraisalForm'),
  // MasterListAdd: () => import('@/views/master/MasterListAdd'),
  // MasterListEdit: () => import('@/views/master/MasterListEdit'),
  // 考试列表
  examinationList: () => import('@/views/master/examinationList'),
  // 身份证列表
  idCardList: () => import('@/views/master/idCardList'),
  // 解散团队列表
  disbandTeamList: () => import('@/views/master/disbandTeamList'),
  // 团长列表
  headList: () => import('@/views/master/headList'),
  // 保证金退回
  marginReturnList: () => import('@/views/master/marginReturnList'),
  // 培训管理
  trainOverview: () => import('@/views/trainOverview/trainOverview'),
  // 培训列表
  trainList: () => import('@/views/trainOverview/trainList'),
  // 师傅查询
  MasterQuery: () => import('@/views/master/MasterQuery'),
  // 我的钱包
  recharge: () => import('@/views/wallet/recharge'),
  walletList: () => import('@/views/wallet/walletList'),
  walletRecord: () => import('@/views/wallet/walletRecord'),
  // 客户验收单
  acceptanceList: () => import('@/views/acceptance/acceptanceList'),
  // 协议确认单
  agreementConfirm: () => import('@/views/finance/agreementConfirm')
}

// 前端未找到页面路由（固定不用改）
const notFoundRouter = {
  path: '*',
  redirect: '/404',
  hidden: true
}

/**
 * 获取后端路由信息的 axios API
 * @returns {Promise}
 */
export const getRouterByUser = () => {
  return axios({
    url: '/system/menu/user',
    method: 'get',
    dataType: 'json'
    /* headers: {
      'Access-Token': 'xxx'
    }
    */
  })
}

/**
 * 获取路由菜单信息
 *
 * 1. 调用 getRouterByUser() 访问后端接口获得路由结构数组
 *    @see https://github.com/sendya/ant-design-pro-vue/blob/feature/dynamic-menu/public/dynamic-menu.json
 * 2. 调用
 * @returns {Promise<any>}
 */
export const generatorDynamicRouter = () => {
  return new Promise((resolve, reject) => {
    // ajax
    getRouterByUser()
      .then(res => {
        const result = buildmenu(res)
        const routers = generator(result)
        routers.push(notFoundRouter)
        resolve(routers)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 格式化 后端 结构信息并递归生成层级路由表
 *
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap, parent) => {
  return routerMap.map(item => {
    const currentRouter = {
      // 路由地址 动态拼接生成如 /dashboard/workplace
      path: `${(parent && parent.path) || ''}/${item.key}`,
      // 路由名称，建议唯一
      name: item.name || item.key || '',
      // 隐藏菜单
      hidden: item.hidden || false,
      // 该路由对应页面的 组件
      component: constantRouterComponents[item.component || item.key],
      hideChildrenInMenu: item.hideChildrenInMenu || false,
      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: { title: item.title, icon: item.icon || undefined, hiddenHeaderContent: item.hiddenHeaderContent || false }
    }
    // 为了防止出现后端返回结果不规范，处理有可能出现拼接出两个 反斜杠
    currentRouter.path = currentRouter.path.replace('//', '/')
    // 重定向
    item.redirect && (currentRouter.redirect = item.redirect)
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      // Recursion
      currentRouter.children = generator(item.children, currentRouter)
    }
    return currentRouter
  })
}

export function buildmenu(rows) {
  const menus = [
    {
      title: '首页',
      key: '',
      name: 'index',
      hidden: true,
      component: 'BasicLayout',
      redirect:
        location.host == '121.41.10.247:8082' ||
          location.host == 'sjlockan.maitewang.com' ||
          location.host == 'localhost:8000'
          ? '/qyindex/workbench'
          : location.host == 'dxsj.mtwlockan.com' || location.host == 'dxsjlockan.maitewang.com'
            ? '/order/dxOrderList'
            : '/dashboard/weclome',
      children: [
        {
          title: '首页',
          key: 'dashboard',
          hidden: true,
          component: 'RouteView',
          redirect:
            location.host == '121.41.10.247:8082' ||
              location.host == 'sjlockan.maitewang.com' ||
              location.host == 'localhost:8000'
              ? '/qyindex/workbench'
              : location.host == 'dxsj.mtwlockan.com' || location.host == 'dxsjlockan.maitewang.com'
                ? '/order/dxOrderList'
                : '/dashboard/weclome',
          icon: 'dashboard',
          children: [
            {
              title: '欢迎页',
              key: 'weclome',
              hidden: true,
              icon: ''
            }
          ]
        }
      ]
    }
  ]
  const arr = []
  buildtree(rows, arr, 0)
  arr.unshift({
    component: 'RouteView',
    hidden: !!(
      location.host == '121.41.10.247:8082' ||
      location.host == 'sjlockan.maitewang.com' ||
      location.host == 'localhost:8000' ||
      location.host == 'dxsj.mtwlockan.com' ||
      location.host == 'dxsjlockan.maitewang.com'
    ),
    icon: 'home',
    key: 'weclome',
    title: '首页'
  })
  // console.log(arr,'buildtree')
  arr.forEach(row => {
    menus[0].children.push(row)
  })
  return menus
}
export function buildtree(list, arr, parentId) {
  list.forEach(item => {
    if (item.parentId === parentId) {
      var child = {
        title: item.menuName,
        key: item.menuKey,
        icon: item.icon,
        hidden: item.visible === '1',
        component: item.menuType === 'M' ? item.menuLay : undefined,
        children: []
      }
      buildtree(list, child.children, item.menuId)
      if (child.children.length === 0) {
        delete child.children
        // delete child.component
      }
      arr.push(child)
    }
  })
}
